import { render } from "./DashboardKpiGrid.vue?vue&type=template&id=147e6a0e&scoped=true"
import script from "./DashboardKpiGrid.vue?vue&type=script&lang=js"
export * from "./DashboardKpiGrid.vue?vue&type=script&lang=js"

import "./DashboardKpiGrid.vue?vue&type=style&index=0&id=147e6a0e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-147e6a0e"]])

export default __exports__